/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

export default function MarkerIcon({ width, height, color }) {
  return (
    <svg width={width} height={height} viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_7724_5232" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width={width} height={height}>
        <path d="M16 0H0V14H16V0Z" fill={color} />
      </mask>
      <g mask="url(#mask0_7724_5232)">
        <mask id="mask1_7724_5232" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width={width} height={height}>
          <path d="M0 1.90735e-06H16V14H0V1.90735e-06Z" fill="white"/>
        </mask>
        <g mask="url(#mask1_7724_5232)">
          <path d="M11.705 13.5237L8.08309 12.2258C7.8325 12.136 7.55162 12.136 7.30106 12.2258L3.67918 13.5237C3.04518 13.7508 2.35034 13.3428 2.35034 12.7434V1.24858C2.35034 0.799105 2.76681 0.434695 3.28053 0.434695H12.1036C12.6173 0.434695 13.0337 0.799105 13.0337 1.24858V12.7434C13.0337 13.3428 12.339 13.7508 11.705 13.5237Z" stroke="#A6B3C2" stroke-width="0.9" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
      </g>
    </svg>
  );
}

MarkerIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

MarkerIcon.defaultProps = {
  width: 16,
  height: 14,
  color: 'white',
};
